import PropTypes from 'prop-types';

export default function IconGoogleColor({ size = 26 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="devicon:google" clipPath="url(#clip0_20_4579)">
        <path
          id="Vector"
          d="M9.55723 0.855137C6.95942 1.75634 4.71908 3.46685 3.16527 5.73542C1.61146 8.00399 0.826083 10.7111 0.924499 13.459C1.02292 16.2069 1.99994 18.8508 3.71205 21.0024C5.42417 23.154 7.78114 24.6999 10.4368 25.413C12.5897 25.9685 14.8454 25.9929 17.0099 25.484C18.9707 25.0436 20.7835 24.1015 22.2708 22.75C23.8188 21.3004 24.9424 19.4563 25.5208 17.4159C26.1493 15.1971 26.2612 12.8638 25.8479 10.595H13.7578V15.6101H20.7596C20.6196 16.41 20.3198 17.1734 19.8779 17.8547C19.436 18.536 18.8613 19.1212 18.188 19.5751C17.3331 20.1409 16.3693 20.5215 15.3585 20.6923C14.3448 20.8809 13.305 20.8809 12.2913 20.6923C11.2638 20.4801 10.2918 20.0561 9.43738 19.4472C8.06456 18.4754 7.03376 17.0948 6.49207 15.5025C5.94138 13.8803 5.94138 12.1217 6.49207 10.4995C6.87765 9.36245 7.51507 8.32716 8.35676 7.47092C9.31996 6.47306 10.5394 5.75979 11.8813 5.40935C13.2232 5.05892 14.6357 5.08487 15.9638 5.48436C17.0013 5.8027 17.9501 6.35917 18.7344 7.10936C19.5239 6.32394 20.312 5.53649 21.0988 4.74701C21.505 4.32248 21.9479 3.91826 22.348 3.48357C21.1507 2.36947 19.7453 1.50251 18.2124 0.932325C15.4208 -0.0812897 12.3664 -0.10853 9.55723 0.855137Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M9.55727 0.855148C12.3662 -0.109174 15.4206 -0.0826512 18.2124 0.930304C19.7456 1.50436 21.1503 2.3755 22.346 3.49374C21.9398 3.92843 21.5112 4.33468 21.0968 4.75718C20.3087 5.54395 19.5212 6.32801 18.7345 7.10937C17.9502 6.35918 17.0014 5.80271 15.9638 5.48437C14.6362 5.08348 13.2237 5.05603 11.8815 5.40503C10.5392 5.75403 9.31902 6.46599 8.35477 7.4628C7.51308 8.31905 6.87566 9.35434 6.49008 10.4914L2.2793 7.23124C3.7865 4.24238 6.39613 1.95613 9.55727 0.855148Z"
          fill="#E33629"
        />
        <path
          id="Vector_3"
          d="M1.16227 10.4609C1.38843 9.33917 1.76418 8.25291 2.27946 7.2312L6.49024 10.4995C5.93955 12.1217 5.93955 13.8803 6.49024 15.5025C5.08732 16.5858 3.68373 17.6745 2.27946 18.7687C0.989919 16.2018 0.596633 13.2772 1.16227 10.4609Z"
          fill="#F8BD00"
        />
        <path
          id="Vector_4"
          d="M13.758 10.593H25.848C26.2613 12.8618 26.1495 15.1951 25.521 17.414C24.9425 19.4543 23.8189 21.2984 22.271 22.748C20.912 21.6877 19.547 20.6355 18.1881 19.5752C18.8619 19.1208 19.4369 18.535 19.8788 17.853C20.3206 17.171 20.6203 16.4067 20.7597 15.6061H13.758C13.756 13.9365 13.758 12.2647 13.758 10.593Z"
          fill="#587DBD"
        />
        <path
          id="Vector_5"
          d="M2.27734 18.7687C3.68161 17.6854 5.08521 16.5966 6.48812 15.5024C7.03089 17.0953 8.06317 18.476 9.4375 19.4471C10.2946 20.0532 11.2687 20.4738 12.2975 20.6821C13.3112 20.8707 14.351 20.8707 15.3647 20.6821C16.3755 20.5113 17.3393 20.1307 18.1942 19.5649C19.5531 20.6253 20.9181 21.6774 22.277 22.7378C20.7899 24.09 18.9771 25.0328 17.0161 25.4738C14.8516 25.9827 12.5959 25.9583 10.443 25.4028C8.74018 24.9481 7.14965 24.1466 5.77109 23.0485C4.3121 21.89 3.12038 20.4301 2.27734 18.7687Z"
          fill="#319F43"
        />
      </g>
      <defs>
        <clipPath id="clip0_20_4579">
          <rect
            width={size}
            height={size}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

IconGoogleColor.propTypes = {
  size: PropTypes.number.isRequired,
};
